/******************************************************************************
 * Copyright (c) 2016 - 2024.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2024-08-28                                                        *
 ******************************************************************************/

export const CATEGORY_UI_TEMPLATES =  {
    SUBCATEGORY_CARDS: {label:'Browse Cards',value:'SUBCATEGORY_CARDS'},
    NON_BTO_STRUCTURE_BTO_SUBCATEGORY: {label:'Offers + Subcategory Browse',value:'NON_BTO_STRUCTURE_BTO_SUBCATEGORY'},
    NON_BTO_STRUCTURE_ONLY: {label:'Offer Placements Only',value:'NON_BTO_STRUCTURE_ONLY'},
    BTO_STRUCTURE_LIST: {label:'Configurable Offer List',value:'BTO_STRUCTURE_LIST'}
};

export const CATEGORY_UI_TEMPLATE_OPTIONS = [
    CATEGORY_UI_TEMPLATES.SUBCATEGORY_CARDS,
    CATEGORY_UI_TEMPLATES.NON_BTO_STRUCTURE_BTO_SUBCATEGORY,
    CATEGORY_UI_TEMPLATES.NON_BTO_STRUCTURE_ONLY,
    CATEGORY_UI_TEMPLATES.BTO_STRUCTURE_LIST,
];
